/** 云控指令合并策略：passthrough=一起发 / override=覆盖 / mask_all=屏蔽所有。 */
export type CloudCmdPolicy = 'passthrough' | 'override' | 'mask_all';

export const CLOUD_CMD_POLICY_OPTIONS: { value: CloudCmdPolicy; label: string }[] = [
  { value: 'passthrough', label: '一起发（默认）' },
  { value: 'override', label: '覆盖' },
  { value: 'mask_all', label: '屏蔽所有' },
];

/** 运行时守卫：取值合法性判断的唯一入口，避免各页面重复字面量清单（新增策略时只改这里）。 */
export const isCloudCmdPolicy = (value: unknown): value is CloudCmdPolicy =>
  CLOUD_CMD_POLICY_OPTIONS.some((option) => option.value === value);

export const CLOUD_CMD_POLICY_HINT =
  '仅作用于云控指令 cloud_cmd：一起发=record 里的指令与下方云控事件合成的都发；覆盖=丢弃 record 里的指令，只发云控事件合成的；屏蔽所有=record 里的和云控事件合成的都不发。';